<script>
    import { onMount } from "svelte";

    import { fade } from "svelte/transition";

    import { isObjectEmpty } from "../../../../../Utils/utilFunctions.svelte";

    import {
        convertTimeRangeInMin,
        convertTitleToMin,
        updateTimeItems,
    } from "../../../helpers/mbsHelper.svelte";

    import {
        addMinutesToTime,
        initTimeObj,
    } from "../../../helpers/encounterHelper.svelte";
    import SearchSelect from "../../../../../Components/Common/SearchSelect.svelte";
    import Select from "svelte-select/Select.svelte";

    export let itemProps = {},
        selectedItems = [],
        defaultItems = [],
        procedureRef,
        updateItems = () => {};

    // For Item Time Selector
    export let timeObj = {};

    $: isEncounterTypeConsult = itemProps.billingType == 1;

    $: isEncounterTypeLabourEpidural = itemProps.billingType == 2;

    $: isCardiacEncounter = itemProps.billingType == 3;

    // Consult && Labour Epidural encounters time selector only change time range NOT add related time code
    $: shouldTimeSelectorOnlyAddTime =
        isEncounterTypeConsult || isEncounterTypeLabourEpidural;

    $: if (defaultItems.length) _syncTimeOptions();

    $: selectedTimeIsBiggerThan8Hours = timeIsBiggerThan8Hours(selectedOption);

    $: syncSelectedTimeFromOtherSection(selectedItems);

    let allTimeOptions = [],
        displayTimeOptions = [],
        isInBigRange = false,
        selectedOptionIndex = 0,
        selectedOption = {};

    let searchedTime;

    onMount(() => {
        handleTimeChange();

        if (selectedItems.some((item) => item.infoType == "Time")) {
            const selectedItem = selectedItems.find(
                (item) => item.infoType == "Time",
            );

            allTimeOptions.map((item, i) => {
                if (item.itemNum == selectedItem.itemNum)
                    _updateOptionByIndex(i);
            });
        }
    });

    const handleChangeTime = (e) => {
        _updateOptionByIndex(e.target.value);

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj();
    };

    const handleSelectPrev = (selectedOptionIndex) => {
        if (selectedOptionIndex) _updateOptionByIndex(selectedOptionIndex - 1);
        else _updateOptionByIndex(displayTimeOptions.length - 1);

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj();
    };

    const handleSelectNext = (selectedOptionIndex) => {
        if (selectedOptionIndex < displayTimeOptions.length - 1)
            _updateOptionByIndex(selectedOptionIndex + 1);
        else _updateOptionByIndex(0);

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj();
    };

    const handleToggleRange = () => {
        isInBigRange = !isInBigRange;

        if (isInBigRange) displayTimeOptions = [...allTimeOptions];
        else displayTimeOptions = allTimeOptions.slice(0, 24);
    };

    const handleTimeChange = (func, isFromTimeInput = false) => {
        if (func) func();
        else if (isObjectEmpty(timeObj))
            timeObj = initTimeObj(itemProps, timeObj);
        else if (isFromTimeInput) _syncTimeItemFromTimeInput();
    };

    const syncSelectedTimeFromOtherSection = (selectedItems = []) => {
        if (
            !selectedItems.length ||
            !selectedItems.some(
                ({ infoType }) => infoType.toLowerCase() === "time",
            )
        ) {
            selectedOption = {};
            selectedOptionIndex = 0;
            return;
        }

        const selectedTimeItem = selectedItems.find(
            ({ infoType }) => infoType.toLowerCase() === "time",
        );

        if (!selectedOption || isObjectEmpty(selectedOption)) {
            selectedOption = { ...selectedTimeItem };

            const index = allTimeOptions.findIndex(
                (item) => item.itemNum == selectedOption.itemNum,
            );

            _updateOptionByIndex(index);
        }
    };

    // HELPER FUNCTIONS
    const _syncTimeOptions = () => {
        defaultItems.map((item) => {
            item.timeBigEdge = convertTitleToMin(item.infoShortTitle)[1];
        });

        allTimeOptions = defaultItems.sort(
            (a, b) => a.timeBigEdge - b.timeBigEdge,
        );

        displayTimeOptions = allTimeOptions.slice(0, 24);
    };

    const _updateOptionByIndex = (index) => {
        selectedOptionIndex = index;
        selectedOption = allTimeOptions[index];
    };

    const _syncTimeItemFromTimeInput = () => {
        if (isObjectEmpty(timeObj) || shouldTimeSelectorOnlyAddTime) return;

        const { startTime, endTime } = timeObj;

        if (!startTime || !endTime) return;
        const formatStartTime = `1900-01-01T${startTime}`;
        // if endTime < startTime then take endTime as next day
        const formatEndTime =
            endTime < startTime
                ? `1900-01-02T${endTime}`
                : `1900-01-01T${endTime}`;

        const timeDiff = convertTimeRangeInMin(formatStartTime, formatEndTime);

        const targetTimeOptionIndex = allTimeOptions.findIndex((item) => {
            const timeRange = convertTitleToMin(item.infoShortTitle);

            return timeDiff >= timeRange[0] && timeDiff <= timeRange[1];
        });

        if (!targetTimeOptionIndex && targetTimeOptionIndex != 0) return;

        _updateOptionByIndex(targetTimeOptionIndex);

        updateItems(updateTimeItems(selectedOption, selectedItems));
    };

    const _syncAdditionalProcedureItems = () => {
        const { billingType, neuraxialType } = itemProps;

        if (billingType != 2 || !neuraxialType || isObjectEmpty(timeObj))
            return;

        const { startTime, endTime } = timeObj;

        if (!startTime || !endTime) return;

        const formatStartTime = `1900-01-01T${startTime}`;
        // if endTime < startTime then take endTime as next day
        const formatEndTime =
            endTime < startTime
                ? `1900-01-02T${endTime}`
                : `1900-01-01T${endTime}`;

        const item =
            neuraxialType == 1
                ? { key: 1, value: "Insertion" }
                : neuraxialType == 2
                  ? { key: 2, value: "Top up | Revision" }
                  : null;

        itemProps.startDate = formatStartTime;
        itemProps.endDate = formatEndTime;

        procedureRef.handleSelectItem(item, false);
    };

    const _syncTimeObj = () => {
        if (isObjectEmpty(timeObj)) return;

        const { startTime, endTime } = timeObj;

        if (!startTime && !endTime) return;

        const totalMins = convertTitleToMin(selectedOption.infoShortTitle)[1];

        if (startTime) timeObj.endTime = addMinutesToTime(startTime, totalMins);
        else timeObj.startTime = addMinutesToTime(endTime, -totalMins);
    };

    const timeIsBiggerThan8Hours = (selected) => {
        //check if first char of the description starts with 8, or a bigger number
        if(selected != null && !isObjectEmpty(selected)){
            var parts = selected.infoShortTitle.split(":");
            if(parts[0].length == 1 || parts[0].length == 2){
                //convert it to number
                var partNumber = parseInt(parts[0]);
                if(partNumber >=8)
                    return true;
            }
        }

        return false;
    }

    let searchText = "";

    function timeToMinutes(timeStr) {
        const match = String(timeStr).trim().match(/^(\d{1,2}):(\d{2})$/);
        if (!match) return null;

        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);

        if (minutes < 0 || minutes > 59) return null;

        return hours * 60 + minutes;
    }

    function minutesToTime(totalMinutes) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours}:${String(minutes).padStart(2, "0")}`;
    }

    function extractRange(label) {
        if (!label) return null;

        const match = String(label).match(
            /(\d{1,2}:\d{2})\s*HOURS\s*TO\s*(\d{1,2}:\d{2})\s*HOURS/i,
        );

        if (!match) return null;

        const start = timeToMinutes(match[1]);
        const end = timeToMinutes(match[2]);

        if (start == null || end == null) return null;

        return { start, end };
    }

    function parseSearchToMinutes(search) {
        if (!search) return null;

        const value = String(search).trim();

        // case 1: "95" => 95 minutes => 1:35
        if (/^\d+$/.test(value)) {
            return parseInt(value, 10);
        }

        // case 2: "1:35"
        if (/^\d{1,2}:\d{2}$/.test(value)) {
            return timeToMinutes(value);
        }

        return null;
    }

    function customFilter(itemLabel, search, item) {
        if (!search || !String(search).trim()) return true;

        const rawSearch = String(search).trim().toLowerCase();
        const label = String(item.infoShortTitle || "").toLowerCase();
        const itemNum = String(item.itemNum || "").toLowerCase();

        // normal text/code search
        if (label.includes(rawSearch) || itemNum == rawSearch) {
            return true;
        }

        // semantic time search: "95" or "1:35"
        const searchedMinutes = parseSearchToMinutes(rawSearch);
        if (searchedMinutes == null) return false;

        const range = extractRange(item.infoShortTitle);
        if (!range) return false;

        return searchedMinutes >= range.start && searchedMinutes <= range.end;
    }
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center justify-between gap-x-4">
        <p class="w-auto min-w-[6rem] font-bold text-lg">
            Time {itemProps.itemType == "quote" ? "for quote" : ""}
        </p>
        <div class="w-[50%] items-center gap-x-2">
            <Select
                bind:value={searchedTime}
                class="flex flex-1 max-h-[35px] rounded-full"
                items={allTimeOptions}
                itemId="itemNum"
                label="infoShortTitle"
                itemFilter={customFilter}
                on:clear={() => {
                    searchedTime = null;
                }}
                on:change={() => {
                    const selected = allTimeOptions.find(
                        (option) => option.itemNum == searchedTime.itemNum,
                    );

                    if (selected) {
                        const index = allTimeOptions.findIndex(
                            (option) => option.itemNum == selected.itemNum,
                        );

                        _updateOptionByIndex(index);
                        updateItems(updateTimeItems(selectedOption, selectedItems));
                        _syncTimeObj();
                        searchedTime = null;
                    }
                }}
                noOptionsMessage="No time code found"
                placeholder="Search time code (minutes ex: 95, hours ex: 1:35, item num ex: 23075)"
                --placeholder-color="#9CA3AF"
                --height="32px"
                --value-container-padding="0"
                --padding="0 0 0 12px"
                --font-size="14px"
            />  
        </div>
    </div>

    {#if !isEncounterTypeLabourEpidural}
        <div class="flex flex-1 items-center justify-between">
            <p>
                {selectedOption?.infoShortTitle
                    ? selectedOption.infoShortTitle
                    : "No time range selected"}
            </p>

            <div class="flex items-center gap-x-2">
                <button
                    class="btn btn-secondary btn-sm text-[#fff]"
                    on:click|preventDefault={() =>
                        handleTimeChange(handleSelectPrev(selectedOptionIndex))}
                >
                    <i class="fa faIcon">&#xf104;</i>
                </button>

                <button
                    class="btn btn-secondary btn-sm text-[#fff]"
                    on:click|preventDefault={() =>
                        handleTimeChange(handleSelectNext(selectedOptionIndex))}
                >
                    <i class="fa faIcon">&#xf105;</i>
                </button>
            </div>
        </div>

        <div class="flex flex-1 flex-col px-4">
            <input
                type="range"
                class="range range-secondary"
                min="0"
                max={Number(displayTimeOptions.length - 1)}
                value={selectedOptionIndex}
                step="1"
                on:input|preventDefault={(e) =>
                    handleTimeChange(handleChangeTime(e, selectedItems))}
            />
        </div>

        <div class="flex flex-1 items-center justify-end">
            <p
                class="text-secondary underline cursor-pointer"
                on:click|preventDefault={handleToggleRange}
            >
                Show {isInBigRange ? "Short" : "Long"} Range
            </p>
        </div>
    {/if}

    {#if itemProps.itemType == "invoice"}
        <div class="flex flex-1 items-center gap-x-8">
            <div class="flex items-center gap-x-2">
                <p class="text-md">Start Time:</p>
                <input
                    type="time"
                    class="input input-sm input-bordered"
                    bind:value={timeObj.startTime}
                    on:change={() => handleTimeChange(undefined, true)}
                    on:blur={_syncAdditionalProcedureItems}
                />
            </div>
            <div class="flex items-center gap-x-2">
                <p class="text-md">End Time:</p>
                <input
                    type="time"
                    class="input input-sm input-bordered"
                    bind:value={timeObj.endTime}
                    on:change={() => handleTimeChange(undefined, true)}
                    on:blur={_syncAdditionalProcedureItems}
                />
            </div>
        </div>
    {/if}
    {#if selectedTimeIsBiggerThan8Hours}
        <div class="text-rose-600 text-center">
            <b>WARNING</b>: Time code selected is over 8 hours. Please ensure this is intended.
        </div>
    {/if}
</div>
